import React, { Component } from 'react';
import Apng from 'react-apng';
import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'

import './style.less';
import gift from '../../static/images/homework-new/diamond.png';
// import audioOpen from '../../static/audio/open_gift.mp3';
import audioCount from '../../static/audio/diamond_count.mp3';

class HomeworkResult extends Component {
    constructor(props){
        super(props);
        this.clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
        this.countInit = 1600 / this.clientWidth;
        this.defaultCnt = props.awardCnt;
        this.state = {
            count: props.awardCnt,
            // count: 12,
            actionDone: props.awardCnt === 0,
            giftStatus: 'close',
            starArr: []
        };
        this.timeOutArr = [];
    }
    componentDidMount = () => {
        const { count } = this.state;
        count === 0 && this.addstarFun();
        clientApi.completeHomework();
    }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }
    addstarFun = () => {
        const starnum = this.props.starnum * 2;
        let array = [];
        let starArr = [];
        for (let i = 0; i < 10; i++) {
            if(starnum  - i > 0) array.push(1);
            else array.push(0)
        }
        for(let i = 0 ; i < array.length ; i++){
            if(i%2 !== 0){ starArr.push(array[i] + array[i-1]) }
        }
        this.setState({
            starArr: starArr
        })
    }
    openGift = () => {
        this.audioCount.play();
        this.setState({
            giftStatus: 'open',
        },() => {
            this.timeOutArr.push(
                setTimeout(() => {
                    this.setState({showApng: true});
                    this.countFun();
                }, 1000)
            )
        });
        clientApi.eventTracking({eventType:`c2_app_HomeWork_End_GiftBox`});
    }
    countFun = () => {
        const { count } = this.state;
        if(count < 0) {
            this.gift.stop();
            this.audioCount.pause();
            this.addstarFun();
            this.setState({actionDone: true});
            return false;
        }
        setTimeout(() => {
            this.setState({count: count - 1})
            this.countFun();
        }, 220);
    }
    render(){
        const { actionDone, count, showApng, giftStatus, starArr } = this.state;
        const starItem = starArr.map((ele,index)=>{
            return <div key={index} className={`star icons ${ele===0 ? '' : ele === 1 ? 'half' : 'complete'}`}></div>
        });
        return(
            <div className="container homework_new result">
                {actionDone ?
                    <div>
                        <div className="title"></div>
                        <div className="star_wrap">{starItem}</div>
                        <div className="icons btn done" onClick={
                            ()=>{
                                clientApi.eventTracking({eventType:'c2_app_HomeWork_End_Complete'});
                                clientApi.closeH5Page({reason: 'homeworkDone'});
                            }
                        } /> 
                    </div>
                    :
                    <div className="dimond">
                        <div className={`gift ${giftStatus}`} />
                        {showApng ?
                            <div>
                                <Apng
                                    className="action_wrap"
                                    src={gift}
                                    rate={1}
                                    autoPlay={true}
                                    ref={com => (this.gift = com)}
                                />
                                <div className="count count1">+{count}</div>
                                <div className="count count2">{this.defaultCnt - count}</div>
                            </div>
                            :
                            <div>
                                {giftStatus === 'close' && 
                                    <div className="finger" />
                                }
                                {giftStatus === 'close' && 
                                    <div className="gift_hide" onClick={this.openGift} />
                                }
                            </div>
                        }
                    </div>
                }
                {/* <audio preload='auto' ref={ com => {this.audioOpen = com} } src={audioOpen}></audio> */}
                <audio preload='auto' ref={ com => {this.audioCount = com} } src={audioCount}></audio>
            </div>
        )
    }
}

export default HomeworkResult;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/HomeworkResult.jsx